import { ref, onBeforeUnmount } from 'vue';

// A message received this recently can still be waiting for its file to reach the storage.
export const RECENT_MESSAGE_SECONDS = 120;
// How long a recent message keeps showing the loading state before reporting the failure.
export const FAILURE_DELAY_MS = 30000;

// Decides when a media load error is a real failure. While the file may still be arriving
// the component should show a loading state instead of "loading failed".
export const useAttachmentLoadState = createdAt => {
  const hasFailed = ref(false);
  let failureTimer = null;

  const clearFailureTimer = () => {
    clearTimeout(failureTimer);
    failureTimer = null;
  };

  const markLoadFailure = () => {
    clearFailureTimer();
    const messageAgeInSeconds = Date.now() / 1000 - createdAt.value;
    if (messageAgeInSeconds > RECENT_MESSAGE_SECONDS) {
      hasFailed.value = true;
      return;
    }
    failureTimer = setTimeout(() => {
      hasFailed.value = true;
    }, FAILURE_DELAY_MS);
  };

  const reset = () => {
    clearFailureTimer();
    hasFailed.value = false;
  };

  onBeforeUnmount(clearFailureTimer);

  return { hasFailed, markLoadFailure, reset };
};
